export default __webpack_public_path__ + "static/media/Template13.51acc078.png";